import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React, { useState } from 'react';

import { baseTheme } from '../../../theme';
import ShareModal from '../../share-components/share-modal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    disabled: {
      color: theme.palette.text.disabled,
    },
  }),
);

export default function PostListItemMenu(props: any) {
  const classes = useStyles(baseTheme);
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const handleEdit = (event: any) => {
    props.handleEdit();
    props.handleClose(event);
  };

  const handleDelete = (event: any) => {
    props.handleDelete();
    props.handleClose(event);
  };
  const handlePrint = (event: any) => {
    props.handleClose(event);
    console.log('I would enter print mode.......');
  };
  const handleShare = (event: any) => {
    setShareModalOpen(true);
  };
  const closeShareModal = () => {
    setShareModalOpen(false);
  };

  return (
      <React.Fragment>
        <MenuList className={classes.root}>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
          {props.groupType === 'Public' ?
              (<MenuItem disabled={false} onClick={handleShare}>Share</MenuItem>) :
              null}
        </MenuList>
        <ShareModal post={props.post} isOpen={shareModalOpen} closeShareModal={closeShareModal} />
      </React.Fragment>
  );
}
